<template>
  <el-col class="displayLayout" id="correctingHistoryManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="批改订单状态">
          <el-select v-model="formInline.endorStatus" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="待确认" value="0"></el-option>
            <el-option label="待支付" value="1"></el-option>
            <el-option label="已支付" value="2"></el-option>
            <el-option label="已取消" value="4"></el-option>
            <el-option label="退款中" value="5"></el-option>
            <el-option label="退款成功" value="6"></el-option>
            <!--<el-option label="退款失败" value="7"></el-option>-->
            <el-option label="待审核" value="13"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="批改状态">
          <el-select v-model="formInline.isInsuredStatus" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="未生效" value="0"></el-option>
            <el-option label="已生效" value="1"></el-option>
            <el-option label="已注销" value="2"></el-option>
            <el-option label="已被拒保" value="3"></el-option>
            <el-option label="核保中" value="4"></el-option>
            <el-option label="投保失败" value="5"></el-option>
            <el-option label="待审核" value="6"></el-option>
            <el-option label="已生效" value="7"></el-option>
            <el-option label="已退保" value="8"></el-option>
            <el-option label="已失效" value="9"></el-option>
            <el-option label="待处理退保" value="10"></el-option>
          </el-select>
        </el-form-item>
        <br/>
        <el-form-item label="批改期间">
          <el-date-picker
            v-model="formInline.issueDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="保单号">
          <el-input v-model="formInline.accode" placeholder="请输入您要查询的保单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">搜索</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="id"
                         width="110"
                         label="批单号码">
        </el-table-column>
        <el-table-column prop="issueDate"
                         width="170"
                         label="批单录入日期">
        </el-table-column>
        <el-table-column prop="accode"
                         width="220"
                         label="保单号">
        </el-table-column>
        <el-table-column prop="name"
                         width="110"
                         label="投保人">
        </el-table-column>
        <el-table-column width="120"
                         label="批改订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.endorStatus==0">待确认</div>
            <div v-if="scope.row.endorStatus==1">待支付</div>
            <div v-if="scope.row.endorStatus==2">已支付</div>
            <div v-if="scope.row.endorStatus==3">长时间未支付</div>
            <div v-if="scope.row.endorStatus==4">已取消</div>
            <div v-if="scope.row.endorStatus==5">退款中</div>
            <div v-if="scope.row.endorStatus==6">退款成功</div>
            <!--<div v-if="scope.row.endorStatus==7">退款失败</div>-->
            <div v-if="scope.row.endorStatus==13">转账流水待审核</div>
            <div v-if="scope.row.endorStatus==22">未支付</div>
          </template>
        </el-table-column>
        <el-table-column  width="120"
                          label="批改状态">
          <template slot-scope="scope">
            <div v-if="scope.row.isInsuredStatus==0">未生效</div>
            <div v-if="scope.row.isInsuredStatus==1">投保成功</div>
            <div v-if="scope.row.isInsuredStatus==2">已注销</div>
            <div v-if="scope.row.isInsuredStatus==3">已被拒保</div>
            <div v-if="scope.row.isInsuredStatus==4">核保中</div>
            <div v-if="scope.row.isInsuredStatus==5">投保失败</div>
            <div v-if="scope.row.isInsuredStatus==6">待审核</div>
            <div v-if="scope.row.isInsuredStatus==7">已生效</div>
            <div v-if="scope.row.isInsuredStatus==8">已退保</div>
            <div v-if="scope.row.isInsuredStatus==9">已失效</div>
            <div v-if="scope.row.isInsuredStatus==10">待处理退保</div>
          </template>
        </el-table-column>
        <el-table-column label="批改类型" width="130">
          <template slot-scope="scope">
            <div v-if="scope.row.type==0">增员</div>
            <div v-if="scope.row.type==1">减员</div>
            <div v-if="scope.row.type==2">换员</div>
            <div v-if="scope.row.type==3">投保人信息修改</div>
            <div v-if="scope.row.type==4">被保人信息修改</div>
            <div v-if="!$$.isValidObj(scope.row.type)">
              <span v-if="scope.row.changingPremium > 0">增员</span>
              <span v-if="scope.row.changingPremium < 0">减员</span>
              <span v-if="scope.row.changingPremium === 0">换员</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="changingPremium"
                         width="120"
                         label="保费变更(元)">
        </el-table-column>
        <el-table-column label="订单操作">
          <template slot-scope="scope">
            <el-button @click="onToPay(scope.row)" size="mini" v-if="scope.row.endorStatus == 1 && !scope.row.isEjsino" >前往支付</el-button>
            <el-button @click="onContinueEnter(scope.row)" size="mini" v-if="scope.row.endorStatus == 0" >继续录入</el-button>
            <el-button @click="onRevocation(scope.row)" size="mini" v-if="'0,1'.indexOf(scope.row.endorStatus.toString()) >= 0">撤销</el-button>
            <el-button @click="onSee(scope.row)" size="mini" >查看详情</el-button>
            <el-button @click="onDownload(scope.row)"
                       size="mini"
                       :style="{background: $$.isValidObj(scope.row.pdfUrl) ? '#FF7052' : '#cccccc'}"
                       v-if="(scope.row.isInsuredStatus == 1 || scope.row.isInsuredStatus == 7 || scope.row.isInsuredStatus == 9) && $$.isValidObj(scope.row.pdfUrl)">下载批单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
    export default {
      name: "correctingHistoryManagement",
      data() {
        return {
          loading: false,
          page: 1,
          total: 0,
          pageSize: 10,
          tableData: [],
          formInline: {
            accode: '',
            endorStatus: '',
            isInsuredStatus: '',
            issueDate: ''
          }
        }
      },
      watch: {
        '$route' () {
          this.getCorrectingHistoryList();
        }
      },
      methods: {
        //-- 下载批单
        onDownload(row){
          if (this.$$.isValidObj(row.pdfUrl)){
            window.open(row.pdfUrl, '_blank');
          }else {
            this.$message("批单链接还在生成中，请稍后再试!");
          }
        },
        //-- 查看
        onSee(row) {
          let params = {
            orderEndorToken: row.endorOrderToken,
            accode: row.accode,
          };
          sessionStorage.setItem('correctingHistoryDetailsParams', JSON.stringify(params));
          this.$router.push({name: 'correctingHistoryDetails'});
        },
        //-- 前往支付
        onToPay(row) {
          let params = {
            orderEndorToken: row.endorOrderToken,
            accode: row.accode,
          };
          sessionStorage.setItem('securityPaymentParams', JSON.stringify(params));
          this.$router.push({name: 'securityPayment'});
        },
        //-- 继续录入
        onContinueEnter(row) {
          if( row.isEjsino ){
            this.$router.push({name: 'ejsinoInsureDetails', query: {productId: row.productId,endorOrderToken: row.endorOrderToken}});
          }else {
            let params = {
              orderEndorToken: row.endorOrderToken,
              accode: row.accode,
            };
            sessionStorage.setItem('personnelCorrectingParams', JSON.stringify(params));
            this.$router.push({name: 'personnelCorrecting'});
          }
        },
        //-- 撤销
        onRevocation(row) {
          let that = this;
          this.$$.confirm({
            message: '确定撤销？',
            onOk: function () {
              that.axios.post('/management/orderEndorInfoLog/handlerOrderEndor?id=' + row.id).then((response) => {
                let data = response.data;
                if (data.success) {
                  that.$message.success("撤销成功!");

                  that.getCorrectingHistoryList();
                } else {
                  that.$message.error(data.msg);
                }
              })
            }
          });
        },
        handleSizeChange(val) {
          this.page = 1;
          this.pageSize = val;
          this.getCorrectingHistoryList();
        },
        handlePageChange(val) {
          this.page = val;
          //保存到sessionStorage
          // sessionStorage.setItem('orderPage', this.page);
          this.getCorrectingHistoryList();
        },
        onSelect() {
          this.page = 1;
          this.getCorrectingHistoryList();
        },
        getCorrectingHistoryList() {
          this.loading = true;
          if( !this.$$.isValidObj(this.formInline.issueDate) ) this.formInline.issueDate = '';
          this.axios.post('/management/orderEndorInfoLog/orderEndorInfoList?_pageSize='+this.pageSize+'&_current='+this.page,{
            accode:this.formInline.accode,
            endorStatus:this.formInline.endorStatus,
            issueDateBegin: this.formInline.issueDate[0],
            issueDateEnd: this.formInline.issueDate[1],
            type: this.$$.isValidObj(this.$route.query.type) ? this.$route.query.type : 27
          }).then((response) => {
            let data = response.data;
            if (data.success) {
              let {list, pagination } = data.datas;

              this.tableData = list;
              this.page = pagination.current;
              this.total = pagination.total;
              this.loading = false;
            } else {
              this.$message.error(data.msg);
            }

            let height = $('.displayLayout').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
            $('.el-table__body-wrapper').css('height', height);
          })
        }
      },
      mounted() {
        if (!this.$$.checkLogin()) return false;

        /*let thePage = sessionStorage.getItem('orderPage');
        if(thePage == null){
          thePage = 1;
        }
        this.page = Number(thePage);*/
        this.getCorrectingHistoryList();
      }
    }
</script>

<style scoped>
  @import "../../../../../static/css/orderManagement.css";
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/preservation/correctingHistoryManagement.vue